import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const INTERCOM_APP_ID = 'xfths9qj';

const Intercom = () => {
  const user = useSelector(({ auth }) => auth.user);

  useEffect(() => {
    if (!user || user.guest) return undefined;

    let cancelled = false;

    import('@intercom/messenger-js-sdk')
      .then(({ default: IntercomSDK }) => {
        if (cancelled) return;

        IntercomSDK({
          app_id: INTERCOM_APP_ID,
          user_id: user._id,
          name: `${user.forename} ${user.surname}`,
          email: user.username,
          created_at: user.date_created,
        });
      })
      .catch(() => {
        // Intercom is non-critical; ignore load failures.
      });

    return () => {
      cancelled = true;
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user]);

  return null;
};

export default Intercom;
